export default class ScrollNavSide {

    static init() {
        const burger = document.querySelector('.burger');
        if (burger) {
            const navSide = document.querySelector('.nav-side');
            const navSideMenu = document.querySelector('.nav-side-menu');
            const navSideNewsletter = document.querySelector('.nav-side-newsletter');
            const menu = document.querySelector('#menu');
            const body = document.querySelector('body');
            let deactivateTimeout = null;

            const toggleNavSide = () => {
                body.classList.toggle('overflow-hidden');
                clearTimeout(deactivateTimeout);
                if (burger.classList.contains('active')) {
                    deactivateTimeout = setTimeout(() => {
                        // hide menu after transition
                        navSide.classList.remove('active');
                        deactivateTimeout = null;
                    }, 800);
                } else {
                    if (deactivateTimeout === null) {
                        navSide.classList.add('active');
                    }
                }
                navSideMenu.classList.toggle('active');
                navSideNewsletter?.classList.toggle('active');
                menu.classList.toggle('bg-transparent');
                burger.classList.toggle('active');
            };
            burger.addEventListener('click', toggleNavSide, false);
            burger.addEventListener('keydown', toggleNavSide, false);
        }
    }

}
